export enum ThemeName {
    DARK = 'dark',
    LIGHT = 'light',
    GRAY = 'gray',
    GRAY_DARK = 'darkGray',
    BLACK = 'black',
    FORTNITE = 'fortnite'
}

export default {
    DARK: ThemeName.DARK,
    LIGHT: ThemeName.LIGHT,
    GRAY: ThemeName.GRAY,
    GRAY_DARK: ThemeName.GRAY_DARK,
    BLACK: ThemeName.BLACK,
    FORTNITE: ThemeName.FORTNITE
};
